import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

const Accessibe = props => {
  const { isAccessibe, setIsAccessibe } = props
  const offsetX = 20
  const offsetY = 20

  useEffect(() => {
    const subdomain = window.location.hostname
      .split('.')
      .slice(0, -2)
      .join('.')
    if (subdomain === 'mywesterntest' || subdomain === 'mywestern') {
      setIsAccessibe(true)
    } else {
      setIsAccessibe(false)
    }
  }, [])

  const renderScript = () => {
    return (
      <script>{`
        (function () {
          const s = document.createElement('script');
          const h = document.querySelector('head') || document.body;
          s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
          s.async = true;
          s.onload = function () {
            acsbJS.init({
              statementLink: '',
              footerHtml: '',
              hideMobile: false,
              hideTrigger: false,
              disableBgProcess: false,
              language: 'en',
              position: 'right',
              leadColor: '#146FF8',
              triggerColor: '#146FF8',
              triggerRadius: '50%',
              triggerPositionX: 'right',
              triggerPositionY: 'bottom',
              triggerIcon: 'people',
              triggerSize: 'bottom',
              triggerOffsetX: ${offsetX},
              triggerOffsetY: ${offsetY},
              mobile: {
                triggerSize: 'medium',
                triggerPositionX: 'right',
                triggerPositionY: 'bottom',
                triggerOffsetX: ${offsetX},
                triggerOffsetY: ${offsetY},
                triggerRadius: '20'
              }
            });
          };
          h.appendChild(s);
        })();
      `}</script>
    )
  }

  if (!isAccessibe) {
    return null
  }

  return <Helmet>{renderScript()}</Helmet>
}

export default Accessibe
